// extracted by mini-css-extract-plugin
module.exports = {"WhyCols":"WhyCols_WhyCols__2BIYD","IconClass":"WhyCols_IconClass__3Fx1V"};